// extracted by mini-css-extract-plugin
module.exports = {"dotDivider":"DotDivider_dotDivider__nkS0y","dotDivider__dot":"DotDivider_dotDivider__dot__6XIOj"};